export const CODE = 'code=';
export const STATE = 'state=';
export const HS_ACCESS_TOKEN = 'hs_access_token';
export const HS_USER_TYPE = 'hs_user_type';
export const USER_INTERNAL = 'internal';
export const REDIRECT_URI = 'redirect_uri';
export enum StatusCodes {
  OK_GATED = 200,
  OK_INTERNAL = 201,
  UNAUTHORISED = 401,
  BAD_REQUEST = 400,
}
